import './App.css';
import './PageMarketingV2AvailableAds.css';

import { Button } from 'primereact/button';
import AdCreative from './AdCreative';

import img_wifi_gif from './wifi.gif';

function PageMarketingV2AvailableAds({
    creativeURL,
    setCreativeURL,
}) {

    const ads = [
        {
            title: 'Vodafone',
            creative_url: 'https://adtangs.fra1.digitaloceanspaces.com/7fdb86d8-1ff2-43df-8bbe-4825388dc9d0.mp4',
        },
        {
            title: 'Ursus',
            creative_url: 'https://adtangs.fra1.digitaloceanspaces.com/981efe6f-31a4-4438-bbbf-486a6eb0f835.mp4',
        },
        {
            title: 'Orange',
            creative_url: 'https://adtangs.fra1.digitaloceanspaces.com/d9ce6157-6f98-48a0-b210-a41a198ddde9.mp4',
        },
    ]

    const divAds = ads.map(
        ad =>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                    className='mk2-ad'
                    onClick={
                        () => {
                            setCreativeURL(ad.creative_url)
                        }
                    }
                >
                    <div className='mk2-ad-creative-container'>
                        <AdCreative
                            creativeURL={ad.creative_url}
                            creativeExt='mp4'
                            shouldAutoPlay={false}
                            hideControls={true}
                            isMuted={true}
                            height='100%'
                            width='100%'
                            objectFit='contain'
                        />
                    </div>
                    <div style={{ marginLeft: '1em', color: 'black' }}>
                        {ad.title}
                    </div>
                </div>
            </div>
    )

    return (
        <div className='mk2-available-ads'>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className='mk2-available-ads-dot-red' />
                <div className='mk2-available-ads-dot-orange' />
                <div className='mk2-available-ads-dot-green' />
                <div style={{ marginLeft: 'auto' }}>
                    <img
                        src={img_wifi_gif}
                        className='mk2-available-ads-wifi'
                    />
                </div>
            </div>
            {divAds}
        </div>
    )
}

export default PageMarketingV2AvailableAds;